module.exports = __webpack_public_path__ + "img/xray-service-map.e48c100a.jpg";